import { Box, Button, Checkbox, Switch, Typography } from "@mui/material"
import React, { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import BankIcon from "../../components/BankIcon"
import { AmountContainer } from "../../components/AmountContainer"
import LoadingOverlay from "../../components/LoadingOverlay"
import IconBox from "../../components/IconBox"
import {
  BottomContainer,
  CheckboxContainer,
  ContentContainer,
  SwitchContainer,
  TitleStyles,
  ToolButton,
  TopContainer,
  StyledButton,
} from "./styled"
import UIIcon from "../../components/UIIcon"
import { useGetSbpIncomeTransferRequest } from "../../api/hooks/useGetSbpIncomeTransferRequest"
import { useAgreement } from "../../api/hooks/useAgreement"
import { useAcceptSbpIncomeTransferRequest } from "../../api/hooks/useAcceptSbpIncomeTransferRequest"
import { useRejectIncomingM2M } from "../../api/hooks/useRejectIncomingM2M"
import { useSignAgreement } from "../../api/hooks/useSignAgreement"
import { ROUTES_PATHS } from "../../utils/constants"

const M2MPush = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const queryParams = new URLSearchParams(location.search)
  const incomeTransferRequestId = queryParams.get("IncomeRequestId")

  const { data: agreement } = useAgreement()
  const { data, isLoading } = useGetSbpIncomeTransferRequest(incomeTransferRequestId)
  const { mutateAsync: accept, isSuccess } = useAcceptSbpIncomeTransferRequest()
  const { mutate: reject } = useRejectIncomingM2M()
  const { mutateAsync: signAgreement, isSuccess: isSetted } = useSignAgreement()

  const [checked, setChecked] = useState(!agreement?.gaveAgreement)
  const [noConfirmation, setNoConfirmation] = useState(true)

  const handleCancelClick = () => {
    reject(incomeTransferRequestId!)
    navigate(`/`)
  }

  const handleSbpClick = async () => {
    if (!agreement?.gaveAgreement) await signAgreement(true)
    if (agreement?.gaveAgreement || isSetted) await accept(incomeTransferRequestId!)
  }

  const handleClick = () => {
    setChecked(!checked)
  }

  if (isLoading) {
    return <LoadingOverlay />
  }

  if (isSuccess) {
    navigate(
      `/${ROUTES_PATHS.me2meAgreement}/${incomeTransferRequestId}/${ROUTES_PATHS.confirm}`,
    )
  }

  if ((!data && !isLoading) || data?.rejectDetails?.code === "timeout_reject") {
    navigate(
      `/${ROUTES_PATHS.me2meAgreement}/${incomeTransferRequestId}/${ROUTES_PATHS.forbidden}`,
    )
  }

  return (
    <ContentContainer>
      <TopContainer>
        <Typography variant="h3" sx={TitleStyles}>
          Вы запросили перевод
          <br /> на свой счет
        </Typography>
        <IconBox size="lg">
          <BankIcon size={80} logoUrl={data?.bankInfo.logoUrl} />
        </IconBox>
        <Typography variant="h4">{data?.bankInfo.title}</Typography>
        <Typography variant="h2">{data?.amount} P</Typography>
        <Typography variant="h6">Комиссия не взимается</Typography>
      </TopContainer>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          marginBottom: agreement?.gaveAgreement ? "100px" : "",
        }}
      >
        <Typography variant="h4Bold">Счет списания</Typography>
        <AmountContainer />
        <SwitchContainer>
          <Box>
            <Typography variant="h4">Переводы без подтверждения</Typography>
            <Typography variant="h6">
              Денежные средства будут списываться по запросу автоматически
            </Typography>
          </Box>
          <Switch
            checked={noConfirmation}
            onClick={() => {
              setNoConfirmation(!noConfirmation)
            }}
          />
        </SwitchContainer>
      </Box>
      <BottomContainer>
        {!agreement?.gaveAgreement && (
          <CheckboxContainer sx={{ margin: "" }}>
            <Checkbox
              onClick={() => {
                handleClick()
              }}
              checked={checked}
            />
            <Typography variant="subtitle2">
              Нажимая на кнопку «Перевести» я соглашаюсь{" "}
              <a href="/" rel="noreferrer">
                с условиями переводов по СБП
              </a>
            </Typography>
          </CheckboxContainer>
        )}
        <Button
          variant="contained"
          color="info"
          fullWidth
          disabled={!checked}
          onClick={handleSbpClick}
        >
          <ToolButton>
            Пополнить через <UIIcon iconName="sbpIcon" size={46} /> сбп
          </ToolButton>
        </Button>
        <StyledButton
          variant="contained"
          color="secondary"
          onClick={handleCancelClick}
        >
          Отменить
        </StyledButton>
      </BottomContainer>
    </ContentContainer>
  )
}

export default M2MPush
